import { Box, Text } from '@nimbus-ds/components';
import {
  CurrencyType,
  SubscriptionRecurringFrequency,
} from '@tiendanube/common';
import { useFormatCurrency } from 'domains/Billing/hooks';
import { useFrequencyTranslation } from '../../hooks';

interface CurrencyPriceWithFrequencyProps {
  amountValue: number;
  amountCurrency?: CurrencyType;
  recurringInterval?: number;
  recurringFrequency?: SubscriptionRecurringFrequency;
}

export default function CurrencyPriceWithFrequency({
  amountValue,
  amountCurrency,
  recurringInterval,
  recurringFrequency,
}: Readonly<CurrencyPriceWithFrequencyProps>) {
  const formatCurrency = useFormatCurrency();
  const { getFrequencyInterval } = useFrequencyTranslation();

  return (
    <Box display="inline-flex" flexDirection="row" alignItems="baseline">
      <Text>{formatCurrency(amountValue, amountCurrency)}</Text>
      {!!recurringFrequency && !!recurringInterval && (
        <Text fontSize="caption">
          {`/${getFrequencyInterval({
            recurringFrequency,
            recurringInterval,
          })}`}
        </Text>
      )}
    </Box>
  );
}
